import { colors } from '../colors';

export const fillBar = {
  containerBackground: colors.gray[500],
};
